import { render, staticRenderFns } from "./changeEmail.vue?vue&type=template&id=1a5baf4d"
import script from "./changeEmail.ts?vue&type=script&lang=js&external"
export * from "./changeEmail.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports